import type { Content } from "@prismicio/client";
import type { WishlistProps } from "@ui-kit";
import { createContext, useContext } from "react";

export type SliceZoneGameContext = {
  game?: Content.GameDocument;
};

export type SliceContextType<TData = Record<string, unknown>> = {
  t: (key: string) => string;
  wishlistProps: WishlistProps;
  data: TData;
};

const initialState: SliceContextType = {
  t: (key: string) => key,
  data: {},
  wishlistProps: {
    gemsState: "disabled",
    isWishlisted: false,
    onWishlistClick: () => Promise.resolve(),
  },
};

export const SliceContext = createContext<SliceContextType>(initialState);

export const useSliceContext = <
  TData = Record<string, unknown>,
>(): SliceContextType<TData> => {
  const ctx = useContext(SliceContext);
  if (!ctx) {
    throw new Error("Slices must be wrapped within SliceContext.Provider");
  }
  return ctx as SliceContextType<TData>;
};
